import { useObserver } from "mobx-react";
import { useStores } from "../../../store";
import { AiOutlineCloseCircle } from "react-icons/ai";
import Previous from "../../dashboard/Previous";
import { MdInfo, MdInfoOutline, MdOutlineAdd, MdWarning } from "react-icons/md";
import { useEffect } from "react";

export default function PreviousInterviews() {
  const { PopupStore, InterviewStore } = useStores();
  useEffect(() => {
    console.log(InterviewStore.previousInterviewsList);
  }, []);
  return useObserver(() => {
    return (
      PopupStore.previousInterviews && (
        <div className="fixed inset-0  bg-black backdrop-blur-sm bg-opacity-50 flex z-50 justify-center items-center">
          <div className="bg-white py-8 rounded-lg relative  text-left px-10 max-w-[80%] max-h-[80%] ">
            <AiOutlineCloseCircle
              className="absolute right-1 top-2 opacity-70 text-primary cursor-pointer"
              onClick={() => {
                PopupStore.setPreviousInterviews(false);
              }}
            />
            <div className="flex flex-col gap-5 h-full justify-between ">
              <div className="flex flex-col  justify-start gap-2">
                <div className="text-center text-primary text-2xl font-bold">
                  Previous attempts
                </div>
                <p className="text-yellow flex  items-center gap-2">
                  <MdInfoOutline className="hidden md:block" />
                  Here are the previous attempts you have left in middle. You
                  can continue from where you left off.
                </p>
                {!InterviewStore.isAttemptLeft && (
                  <p className="text-red-500  flex items-center gap-2">
                    <MdWarning className="hidden md:block" />
                    Sorry, you have already taken the maximum number of
                    interviews allowed to create a new interview.
                  </p>
                )}
              </div>

              <div className="flex flex-col items-center justify-center max-h-[75%] overflow-y-auto">
                <Previous
                  from={"interview"}
                  handleOnClick={(id) => {
                    const url = `/interview/?continue=${id}`;
                    window.location.href = url;
                  }}
                />
              </div>
              <div className="flex flex-col justify-end h-full gap-2">
                <div className="flex justify-end  w-[100%]">
                  <button
                    onClick={() => {
                      if (InterviewStore.isAttemptLeft) {
                        window.location.href =
                          InterviewStore.interviewNavigationLink;
                      } else {
                        alert(
                          "Sorry, you have already taken the maximum number of interviews allowed."
                        );
                      }
                    }}
                    className={`text-bg3 ${
                      InterviewStore.isAttemptLeft
                        ? "cursor-pointer"
                        : "cursor-not-allowed"
                    } flex flex-row justify-center  mr-3 items-center text-center  text-[18px] font-bold  px-3 rounded-lg py-2 bg-primary   gap-2 `}
                  >
                    <span className="text-[30px] text-white text-center w-8 h-8 flex items-center justify-center rounded-full border-2 border-white ">
                      <MdOutlineAdd />
                    </span>

                    <p className="ml-2">{"Create New Interview"}</p>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    );
  });
}
